import {createRequestDataSource} from '@ngneat/elf-requests';
import {indexationStore} from '@store/settings/indexation/indexation.store';
import {selectAllEntities} from '@ngneat/elf-entities';

export const getIndexationDataSource = createRequestDataSource({
  store: indexationStore,
  data$: () => indexationStore.pipe(
    selectAllEntities(),
  ),
  requestKey: 'getIndexation',
  dataKey: 'indexations',
});
